// 一打开页面就使用rem
window.onload = function () {
  /* 设置rem单位*/
  function setRem() {
    var w = document.documentElement.clientWidth;
    document.querySelector('html').style.fontSize = w / 100 + 'px';
  }
  setRem();
  window.onresize = function () {
    setRem();
  }
};


// WEBPACK FOOTER //
// ./src/statics/js/common.js